(function () {
  'use strict';
  function updateMessages(root) {
    root.querySelectorAll('[data-ceylera-shipping-copy]').forEach(function (node) {
      var country = String(node.getAttribute('data-shipping-country') || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(country)) return;
      var attribute = country === 'CA' ? 'data-shipping-ca' :
        country === 'US' ? 'data-shipping-us' : 'data-shipping-intl';
      var message = node.getAttribute(attribute);
      if (message !== null) node.textContent = message;
    });
  }
  updateMessages(document);
  document.addEventListener('shopify:section:load', function (event) {
    updateMessages(event.target);
  });
})();
